import {ActionProgressState} from "../../../../action-manager/action/action-progress-state";

export class OptimizeProgress extends ActionProgressState {

  public status: string;

}
